import {
    Box,
    Card,
    CardBody,
    Flex,
    Image,
    useColorMode
} from '@chakra-ui/react';
import Logos from '../../images/logos';
import { IBookWithValues } from '../../types';
import { formatCurrency } from '../../utils/format';
import Button from '../button';
import Text from '../text';

interface SignupCardProps {
    bookWithValues: Partial<IBookWithValues>;
    noBooksWithValues: boolean;
    noLinkedBooks: boolean;
}

function SignupCard(props: SignupCardProps) {
    const { bookWithValues, noBooksWithValues, noLinkedBooks } = props;
    const { colorMode } = useColorMode();

    const totalValue = (
            (bookWithValues?.missedValueEstimate || 0) +
            (bookWithValues?.bonus || 0) +
            (bookWithValues?.missedValueParlay || 0)
        )
    const missedValueEstimate = bookWithValues?.missedValueEstimate || 0
    const missedValueParlays = bookWithValues?.missedValueParlay || 0
    const bonus = bookWithValues?.bonus || 0

    const onClickSignUp = (url:string) => {
        window.open(url, "_blank");
    }

    //If theere are no book with Values then just return placeholder Card
    if (noBooksWithValues){
        return (
            <Card
            shadow="none"
            border="1px"
            borderColor={colorMode == 'light' ? 'border' : 'transparent'}
            borderRadius="8px"
            bg={colorMode == 'light' ? 'white' : 'alphaWhite005'}
        >
            <CardBody px="20px" py="30px">
                <Text
                    fontSize="24"
                    py="100px"
                    lineHeight="2"
                >
                    🎉 Congrats, our analysis shows you’re getting close to maximum value! 🎉
                </Text>
            </CardBody>
        </Card>
        )
    }

    if (noLinkedBooks){
        return (
            <Card
            shadow="none"
            border="1px"
            borderColor={colorMode == 'light' ? 'border' : 'transparent'}
            borderRadius="8px"
            bg={colorMode == 'light' ? 'white' : 'alphaWhite005'}
        >
            <CardBody px="20px" py="30px">
                <Text
                    fontSize="24"
                    py="100px"
                    lineHeight="2"
                >
                    Link your betting accounts above to see how you're doing!
                </Text>
            </CardBody>
        </Card>
        )
    }

    return (
        <Card
            shadow="none"
            border="1px"
            borderColor={colorMode == 'light' ? 'border' : 'transparent'}
            borderRadius="8px"
            bg={colorMode == 'light' ? 'white' : 'alphaWhite005'}
        >
            <CardBody px="20px" py="30px">
                <Flex direction="column" align="center" gap="20px">
                    <Image
                        h="40px"
                        maxW="50%"
                        //want to get rid of this issue but cant map string -> abbr for some reason
                        // @ts-ignore
                        src={Logos[colorMode][['fd','dk'].includes(bookWithValues.abbr) ? bookWithValues.abbr + 'Real' : bookWithValues.abbr]}
                        alt="" />
                    <Flex
                        align="center"
                        justify="center"
                        gap="20px"
                        w="full"
                        pb="20px"
                        borderBottom="1px"
                        borderColor={
                            colorMode == 'light'
                                ? 'rgba(36,53,106,0.4)'
                                : 'rgba(255,255,255,0.4)'
                        }
                    >
                        <Text
                            fontSize="30px"
                            lineHeight="36px"
                            fontWeight="700"
                            color="green"
                        >
                            {formatCurrency(totalValue)}
                        </Text>
                        <Text size="md">Total Missed Value</Text>
                    </Flex>
                    <Flex align="center" w="full" gap="10px">
                        <Text
                            w="full"
                            maxW="70px"
                            lineHeight="16px"
                            color="green"
                            textAlign="left"
                            fontSize="13px"
                            as="strong"

                        >
                            {formatCurrency(missedValueParlays)}
                        </Text>
                        <Box
                            w="full"
                            bg={
                                colorMode == 'light'
                                    ? 'rgba(36, 53, 106, 0.1)'
                                    : 'alphaWhite005'
                            }
                            py="4px"
                            px="4px"
                            borderRadius="4px"
                        >
                            <Text fontSize="10px" lineHeight="16px">
                                If you had optimized your parlay betting
                            </Text>
                        </Box>
                    </Flex>
                    <Flex align="center" w="full" gap="10px">
                        <Text
                            w="full"
                            maxW="70px"
                            lineHeight="16px"
                            color="green"
                            textAlign="left"
                            fontSize="13px"
                            as="strong"
                        >
                            {formatCurrency(missedValueEstimate)}
                        </Text>
                        <Box
                            w="full"
                            bg={
                                colorMode == 'light'
                                    ? 'rgba(36, 53, 106, 0.1)'
                                    : 'alphaWhite005'
                            }
                            py="4px"
                            px="4px"
                            borderRadius="4px"
                        >
                            <Text fontSize="10px" lineHeight="16px">
                                If you had gotten the best odds on {bookWithValues?.name?.replace(' Exchange','')}
                            </Text>
                        </Box>
                    </Flex>
                    <Flex align="center" w="full" gap="10px">
                        <Text
                            w="full"
                            maxW="70px"
                            lineHeight="16px"
                            color="green"
                            textAlign="left"
                            fontSize="13px"
                            as="strong"
                        >
                            {formatCurrency(bonus)}
                        </Text>
                        <Box
                            w="full"
                            bg={
                                colorMode == 'light'
                                    ? 'rgba(36, 53, 106, 0.1)'
                                    : 'alphaWhite005'
                            }
                            py="4px"
                            px="10px"
                            borderRadius="4px"
                        >
                            <Text fontSize="10px" lineHeight="16px">
                                In bonuses available
                            </Text>
                        </Box>
                    </Flex>
                    <Button size="sm" mt="10px" onClick={()=>onClickSignUp(bookWithValues.url || '')}>
                        Sign Up Now
                    </Button>
                </Flex>
            </CardBody>
        </Card>
    );
}

export default SignupCard;
